"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SbToast = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _constants = require("./constants");

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SbToast = /*#__PURE__*/function (_Component) {
  _inherits(SbToast, _Component);

  var _super = _createSuper(SbToast);

  function SbToast(props) {
    var _this;

    _classCallCheck(this, SbToast);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "removeEventListeners", function () {
      if (_this.toast) {
        _this.toast.removeEventListener('mouseenter', _this.handleMouseEnter);

        _this.toast.removeEventListener('mouseleave', _this.handleMouseLeave);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleSetTimer", function () {
      var hideTime = _this.props.hideTime;
      _this.hideTimer = setTimeout(_this.handleRemoveToast, hideTime);
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseEnter", function () {
      var freezeOnHover = _this.props.freezeOnHover;

      if (freezeOnHover) {
        _this.timeoutCleanup();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseLeave", function () {
      var autoHide = _this.props.autoHide;

      if (!_this.hideTimer && autoHide) {
        _this.handleSetTimer();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnToastClick", function (event) {
      var _this$props = _this.props,
          onClick = _this$props.onClick,
          closeOnClick = _this$props.closeOnClick;

      if (onClick) {
        onClick(event, _this.handleRemoveToast);
      } else if (closeOnClick) {
        _this.handleRemoveToast();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnCloseButtonClick", function (e) {
      e.stopPropagation();
      var onCloseClick = _this.props.onCloseClick;

      _this.removeEventListeners();

      _this.setState({
        removeButtonClicked: true
      });

      if (onCloseClick) {
        onCloseClick(e);
      }

      _this.handleRemoveToast();
    });

    _defineProperty(_assertThisInitialized(_this), "handleRemoveToast", function () {
      var _this$props2 = _this.props,
          removeToast = _this$props2.removeToast,
          toastId = _this$props2.toastId;

      _this.timeoutCleanup();

      if (removeToast) {
        removeToast(toastId);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "timeoutCleanup", function () {
      clearTimeout(_this.hideTimer);
      _this.hideTimer = null;
    });

    _defineProperty(_assertThisInitialized(_this), "renderCloseButton", function () {
      var closeButton = _this.props.closeButton;

      if (closeButton) {
        return /*#__PURE__*/_react.default.createElement("span", {
          className: "close-toast",
          onClick: _this.handleOnCloseButtonClick
        }, /*#__PURE__*/_react.default.createElement("i", {
          className: "sbi-toast-close"
        }));
      }

      return null;
    });

    _defineProperty(_assertThisInitialized(_this), "renderToastIcon", function () {
      var type = _this.props.type;
      return /*#__PURE__*/_react.default.createElement("i", {
        className: "fa ".concat((0, _utils.getToastIconClassName)(type))
      });
    });

    var _autoHide = props.autoHide;
    _this.hideTimer = null;
    _this.state = {
      removeButtonClicked: false
    };

    if (_autoHide) {
      _this.handleSetTimer();
    }

    return _this;
  }

  _createClass(SbToast, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.toast) {
        this.toast.addEventListener('mouseenter', this.handleMouseEnter);
        this.toast.addEventListener('mouseleave', this.handleMouseLeave);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeEventListeners();
      this.timeoutCleanup();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var removeButtonClicked = this.state.removeButtonClicked;
      var _this$props3 = this.props,
          className = _this$props3.className,
          message = _this$props3.message,
          title = _this$props3.title,
          type = _this$props3.type,
          toastId = _this$props3.toastId,
          style = _this$props3.style;

      if (removeButtonClicked) {
        return null;
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        id: toastId,
        style: style,
        className: "toast ".concat(type, " ").concat(className),
        onClick: this.handleOnToastClick,
        ref: function ref(toast) {
          _this2.toast = toast;
        }
      }, this.renderCloseButton(), /*#__PURE__*/_react.default.createElement("div", {
        className: "toast-icon"
      }, this.renderToastIcon()), /*#__PURE__*/_react.default.createElement("div", {
        className: "toast-data"
      }, title && /*#__PURE__*/_react.default.createElement("div", {
        className: "toast-title"
      }, title), /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)('toast-message', {
          'no-title toast-title': !title
        })
      }, message)));
    }
  }]);

  return SbToast;
}(_react.Component);

exports.SbToast = SbToast;

_defineProperty(SbToast, "propTypes", {
  autoHide: _propTypes.default.bool,
  className: _propTypes.default.string,
  closeButton: _propTypes.default.bool,
  closeOnClick: _propTypes.default.bool,
  freezeOnHover: _propTypes.default.bool,
  hideTime: _propTypes.default.number,
  message: _propTypes.default.node.isRequired,
  onClick: _propTypes.default.func,
  // Custom onClick handler, overrides the onCloseClick prop!
  removeToast: _propTypes.default.func,
  style: _propTypes.default.object,
  // eslint-disable-line
  title: _propTypes.default.node,
  toastId: _propTypes.default.string.isRequired,
  type: _propTypes.default.string,
  onCloseClick: _propTypes.default.func
});

_defineProperty(SbToast, "defaultProps", {
  autoHide: true,
  className: '',
  closeButton: false,
  closeOnClick: false,
  freezeOnHover: true,
  style: null,
  title: null,
  hideTime: 5000,
  onClick: null,
  type: _constants.toastTypes.DEFAULT,
  removeToast: null,
  onCloseClick: null
});
//# sourceMappingURL=sb-toast.js.map